// @flow
import React from 'react';
import ApplicationContext from './ApplicationContext';
import type { LanguageType } from './flowTypes';
import getLanguageFromPath from './utils/getLanguageFromPath';

type Props = {
  children: any,
  appFolder: string,
};
type ProvidedProps = {
};

export type State = {
  language: LanguageType;
};

//TODO: nicer path detection with router and stuff

class ApplicationProvider extends React.Component<Props & ProvidedProps,State> {
  state = {
    language: getLanguageFromPath(window.location.pathname),
  };

  setLanguage(language: LanguageType) {
    this.setState({ language });
  }

  render() {
    const {language} = this.state;
    const {appFolder} = this.props;
    const value ={
      language,
      setLanguage: this.setLanguage.bind(this),
      appFolder: appFolder || '',
    };
    return (
      <ApplicationContext.Provider value={value} >
        {this.props.children}
      </ApplicationContext.Provider>
    );
  }
}

export default ApplicationProvider;



// WEBPACK FOOTER //
// ./src/application/ApplicationProvider.js